import React from 'react';
import styled from 'styled-components';
import { icons } from './icons_src.js';

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  /* Use CSS font-size and color to style the SVG */
  font-size: ${({ size }) => size}px;
  color: ${({ color }) => color};
`;

const Icon = ({ name, size = 18, color = 'currentColor' }) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconWrapper size={size} color={color}>
      <IconComponent />
    </IconWrapper>
  );
};

export default Icon;